import { formatNumberWithDot } from '@utils/functions/formatNumberWithDot';
import { TableColumnsType } from 'antd';
import { ISourcesTableData } from '@entities/reports';
import * as S from './styles';

interface ReportColumnProps {
    columns: string[] | undefined;
}

export const createSourcesColumns = ({
    columns,
}: ReportColumnProps): TableColumnsType<ISourcesTableData> => {
    if (!columns) {
        return [];
    }

    return [
        ...columns?.map((column, index) => ({
            key: `column-${index}`,
            title: column,
            width: '12.5%',
            dataIndex: column === 'Источник' ? 'title' : column,
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'] as any,
            align: (index !== 0 ? 'right' : 'left') as
                | 'right'
                | 'left'
                | 'center',
            render: (value: number | string) => (
                <S.StyledSum $isFirst={index === 0}>
                    {index > 2 ? formatNumberWithDot(value) : value}
                </S.StyledSum>
            ),
        })),
    ];
};
